export function arrangeMenu(fetchedStructure) {
  if (!fetchedStructure.length || !fetchedStructure) return [];
  let defaultMenu = fetchedStructure.filter(item => item.type === 'DEFAULT');
  let data = [];
  for (let menu of defaultMenu) {
    const WithChildren = {
      ...menu,
      children: fetchedStructure.filter(
        item => item.type === 'SUBMENU' && item.parent === menu.id,
      ),
    };
    data.push(WithChildren);
  }
  return data;
}
